<template>
  <div id="SearchDataListContainer" class="SearchDataListContainer">
    <div class="searchDataItem" v-for="(item, index) of searchData" :key="index" @click="handleToDetail(item)">
      <div class="searchDataTimeline" v-if="judgeShowTimeline(item, index)">
        <div class="dividerLine"></div>
        <div class="timeSpan">{{ ykDateFormat('yyyy-MM-dd', item[cardOption.mainDateKey]) }}</div>
      </div>
      <div class="searchDataItemCard">
        <!-- 卡片头 -->
        <div class="cardItemHeader">
          <div class="menuName">{{ cardOption.title }}</div>
          <div class="itemMainDate">
            {{ ykDateFormat('yyyy-MM-dd', item.createTime) }}
            <br />
            {{ item[cardOption.mainPersonKey] }}
          </div>
        </div>

        <!-- 卡片内容 -->
        <div class="cardItemContent">
          <div class="itemContentRowItem" v-for="(col, index) of cardOption.col" :key="index">
            <span class="itemContentRowItemLabel">{{ col.label }}：</span>
            <span class="itemContentRowItemValue">{{ formatData(item[col.key], col.type) }}</span>
          </div>
        </div>
        <div class="cardItemFooter">
          <div class="cardItemFooterRight">
            <div
              v-if="
                cardOption.path === 'Remittance' ||
                  cardOption.path === 'WorkReport' ||
                  cardOption.path === 'MailRecords' ||
                  cardOption.path === 'QuotationApply'
              "
            >
              <i style="color: #409eff" class="el-icon-user-solid" />
              {{ getStateByData(item, cardOption.path) }}
              {{
                getApproverByData(item, cardOption.path) !== '/' ? `(${getApproverByData(item, cardOption.path)})` : ''
              }}
            </div>
            <div v-else>
              <i style="color: #409eff" class="el-icon-user-solid" />
              {{ getStateByData(item) }}
              {{ getApproverByData(item) !== '/' ? `(${getApproverByData(item)})` : '' }}
            </div>
          </div>
          <div class="cardItemFooterLeft"></div>
        </div>
      </div>
    </div>

    <!-- 加载中 -->
    <div class="loadingContainer" v-if="isLoading"><i class="el-icon-loading" /> 加载中...</div>

    <!-- 加载完 -->
    <div v-if="searchData.length === 0">
      <!-- 空数据 -->
      <div class="nullData">
        <img class="nullDataImg" src="../../assets/img/null-data.png" />
        <div class="text">暂无数据</div>
      </div>
    </div>

    <div class="no-detail-data" v-if="searchData.length > 0 && isLoadAll">
      - 没有更多了 -
    </div>
  </div>
</template>
<script>
import { getState, getApprover } from '../../utils/state'

export default {
  props: {
    searchData: {
      type: Array
    },
    cardOption: {
      type: Object
    }
  },
  data() {
    return {
      isLoading: false, // 是否正在加载
      isLoadAll: false // 是否加载完所有数据
    }
  },
  mounted() {
    // 监听滚动事件
    const scrollContainer = document.getElementById('SearchDataListContainer')
    scrollContainer.onscroll = () => {
      // 获取滚动条的滚动位置
      const scrollTop = scrollContainer.scrollTop

      // 如果滚动位置等于滚动容器的高度，则滚动条已滚到底部
      if (scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 50) {
        // 执行某些操作
        this.loadNextPageData()
      }

      // // 获取滚动容器的滚动高度
      // const scrollTop = scrollContainer.scrollTop
      // // 获取滚动容器的可见区域高度
      // const containerHeight = scrollContainer.clientHeight
      // // 获取滚动容器内部内容的高度
      // const contentHeight = scrollContainer.scrollHeight

      // // 判断是否滚动到底部
      // if (scrollTop + containerHeight === contentHeight) {
      //   // 在这里执行你的函数
      //   this.loadNextPageData()
      // }
    }
  },
  methods: {
    // ESLINT非要我写
    getStateByData: getState,
    getApproverByData: getApprover,
    // 格式化数据
    formatData(val, type = 'string') {
      if (type === 'money') {
        return this.$utils.commafy(parseFloat(val), {
          digits: 2
        })
      } else if (type === 'date') {
        return this.ykDateFormat('yyyy-MM-dd', val)
      } else {
        return val
      }
    },
    // 跳转
    handleToDetail(item) {
      this.$emit('toDetail', item)
    },
    // 加载下一页数据
    loadNextPageData() {
      if (!this.isLoading && !this.isLoadAll) {
        this.isLoading = true

        // 主界面获取数据
        this.$emit('loadNextPageData')
      }
    },
    // 判断是否显示
    judgeShowTimeline(item, index) {
      if (
        index >= 1 &&
        this.ykDateFormat('yyyy-MM-dd', item.last_modify_time) ===
          this.ykDateFormat('yyyy-MM-dd', this.searchData[index - 1].last_modify_time)
      ) {
        return false
      } else {
        return true
      }
    }
  },
  computed: {}
}
</script>
<style lang="less" scoped>
.SearchDataListContainer {
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  padding: 5px 20px;
  padding-bottom: 50px;

  overflow: auto;
}
.searchDataTimeline {
  width: 100%;
  height: 20px;
  // line-height: 20px;
  // text-align: center;
  color: #606061;
  font-size: 18px;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
}

.timeSpan {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 0 10px;
  background-color: #fafafa;
}
.dividerLine {
  position: absolute;
  width: 100%;
  height: 1px;
  top: 9px;
  left: 0px;
  background-color: #dddddf;
}
.searchDataItemCard {
  margin: 10px 0;
  padding: 15px 20px;
  width: calc(100% - 40px);
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);

  transition: all 0.3s;

  &:active {
    opacity: 0.5;
  }
}
.menuName {
  font-size: 24px;
  color: #333;
  font-weight: bold;
}
.itemMainDate {
  font-size: 14px;
  color: #b0aaa8;

  text-align: right;
}
.cardItemHeader {
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
}

.cardItemContent {
  width: 100%;

  box-sizing: border-box;
  padding: 5px;
  .itemContentRowItem {
    width: 100%;
    margin-top: 10px;
    font-size: 18px;

    word-wrap: break-word;

    .itemContentRowItemLabel {
      color: #9a8987;
    }
    .itemContentRowItemValue {
      color: #666;
    }
  }
}

.cardItemFooter {
  // display: flex;
  // justify-content: space-between;
  font-size: 18px;
  margin-top: 10px;
}
// .cardItemFooterLeft {
// }
.cardItemFooterRight {
  color: #666;
}
.loadingContainer {
  text-align: center;
  padding: 5px 0;
}
// 没有明细数据时的展示
.no-detail-data {
  height: 80px;
  color: #bbbbbb;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nullData {
  width: 100%;
  // height: 700px;
  height: calc(100vh - 50px - 200px);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;

  img {
    width: 60%;
  }

  .text {
    text-align: center;
    width: 100%;
    color: rgba(191, 191, 191, 100);
    font-size: 22px;
    font-family: PingFangSC-bold;
  }
}
</style>
